import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const QuizTemplateModeModal = ({ open, onClose,onContinue, onManual, onAI }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = () => {
    setIsLoading(true);
    // Simulate an API call
    setTimeout(() => {
      setIsLoading(false);
      onContinue();
    }, 3000);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth PaperProps={{ style: { borderRadius: '30px', padding: '32px', maxWidth: '40%' } }}>
      <Box sx={{ position: 'relative' }}>
        <img 
          src={"/Image/ai_quiz/question-mark-2.png"} 
          alt="Chat bubble" 
          style={{ 
            position: 'absolute',
            top: '-12%',
            left: '0%',
            width: '22%',
            zIndex: 1
          }} 
        />
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: "1.75rem",
            marginTop: 6
          }}
          align="center"
        >
          How do you want to create the quiz template?
        </DialogTitle>
      </Box>

      <DialogContent>
        <Box sx={{ display: "flex", gap: 5, position: "relative", padding: '0 1.5rem', marginBottom: '2rem' }}>
          {isLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 1,
              }}
            >
              <img src={"/Image/ai_quiz/ai-loader.gif"} alt="Loading..." style={{ width: "25%" }} />
            </Box>
          )}
          <Card
            sx={{ 
              flex: 1, 
              cursor: "pointer", 
              boxShadow: " 9.36px 5.04px 18px 5.76px rgba(142, 142, 142, 0.25),inset 0px 0px 18px 0.72px rgba(215, 31, 36, 0.5)", 
              borderRadius: "0.875rem", 
              backgroundColor: "#FFFFFF",
              transition: 'background-color 0.3s',
              '&:hover': {
                backgroundColor: '#fff3e0'
              }
            }}
            onClick={onManual}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, height: '120px' }}>
              <img src={"/Image/document-icon.svg"} alt="Manual Creation" style={{ width: '120px', height: '120px', objectFit: 'contain' }} />
            </Box>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 600, fontSize:'1.125rem', fontFamily: 'Montserrat' }} gutterBottom>
                Manual Creation
              </Typography>
              <Typography sx={{ fontWeight: 400, fontSize:'0.875rem', fontFamily: 'Montserrat' }} color="#000000">
                Add questions one by one, customize every detail to match your
                teaching style.
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{ 
              flex: 1, 
              cursor: "pointer", 
              boxShadow: " 9.36px 5.04px 18px 5.76px rgba(142, 142, 142, 0.25),inset 0px 0px 18px 0.72px rgba(215, 31, 36, 0.5)",  
              borderRadius: "0.875rem", 
              backgroundColor: "#FFFFFF",
              transition: 'background-color 0.3s',
              '&:hover': {
                backgroundColor: '#fff3e0'
              }
            }}
            onClick={onAI}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, height: '120px' }}>
              <img src={"/Image/ai-chip.svg"} alt="AI-Powered Creation" style={{ width: '120px', height: '120px', objectFit: 'contain' }} />
            </Box>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 600, fontSize:'1.125rem', fontFamily: 'Montserrat' }} gutterBottom>
                AI Powered Creation
              </Typography>
              <Typography sx={{ fontWeight: 400, fontSize:'0.875rem', fontFamily: 'Montserrat' }} color="#000000">
                Let AI instantly create a full quiz based on your topic or
                content.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </DialogContent>

      {/* <DialogActions>
        <Button
          variant="contained"
          sx={{ 
            borderRadius: "28px",
            backgroundColor: "#D71F24",
            color: "white",
            '&:hover': {
              backgroundColor: "#D71F24"
            }
          }}
          onClick={handleContinue}
          disabled={isLoading}
        >
          Continue
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default QuizTemplateModeModal;
